<template>
  <div class="min-h-screen">
    <layout />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useSettingsStore } from '@/stores/settings'
import { useAuthStore } from './stores/auth'

const store = useSettingsStore()
const authStore = useAuthStore()

onMounted(async () => {
  document.documentElement.classList.add(localStorage.getItem('color-theme') || 'light')
  const user = localStorage.getItem('asl_user')
    ? JSON.parse(localStorage.getItem('asl_user')!)
    : null
  if (user.role === 'admin') {
    await store.fetchSettings()
  }
  if (user.role === 'inventory_admin') {
    await authStore.fetchUser()
  }
  if (user.role === 'superadmin' && authStore.accessibleOrganizations.length === 0) {
    await authStore.fetchOrganizations()
  }
})
</script>

<style scoped></style>
